import { Injectable } from '@angular/core';
import { ApiHttp, HttpOptions } from '@core/api/api-http';
import { environment } from '@env/environment';
import { combineLatest, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConsolidatedTask } from '../models/task';

@Injectable({
  providedIn: 'root'
})
export class ConsolidatedTaskService {
  constructor(private http: ApiHttp) {}

  getTasks(ownedFilter: boolean): Observable<ConsolidatedTask.Model[]> {
    let httpOptions = ApiHttp.getStandardOptions();
    const params = { owned: ownedFilter || false };
    httpOptions = {
      headers: ApiHttp.getStandardOptions().headers,
      params
    };
    return combineLatest([
      this.getTasksFromContactsApi(httpOptions),
      this.getTasksFromOpportunitiesApi(httpOptions)
    ]).pipe(map(([tasks1, tasks2]) => [...tasks1, ...tasks2]));
  }

  private getTasksFromContactsApi(
    httpOptions: HttpOptions
  ): Observable<ConsolidatedTask.Model[]> {
    return this.http.get<ConsolidatedTask.Model[]>(
      environment.clientsApiUrl,
      'tasks',
      httpOptions
    );
  }

  private getTasksFromOpportunitiesApi(
    httpOptions: HttpOptions
  ): Observable<ConsolidatedTask.Model[]> {
    return this.http.get<ConsolidatedTask.Model[]>(
      environment.opportunityApiUrl,
      'tasks',
      httpOptions
    );
  }
}
